import { combineReducers } from 'redux'

// Reducers
import errorReducer from './error-reducer';

import intlReducer from './intl-reducer';
import menuReducer from './menu-reducer';
import userReducer from './user-reducer';
import gameReducer from './game-reducer';
import loginReducer from './login-reducer';
import modalReducer from './modal-reducer';
import winnerReducer from './winner-reducer';
import ticketReducer from './ticket-reducer';
import loadingReducer from './loading-reducer';
import locationReducer from './location-reducer';

// Combine Reducers
const reducers = combineReducers({
	errorState: errorReducer,
  intlState: intlReducer,
	menuState: menuReducer,
	userState: userReducer,
	gameState: gameReducer,
	loginState: loginReducer,
	modalState: modalReducer,
	winnerState: winnerReducer,
	ticketState: ticketReducer,
	loadingState: loadingReducer,
	locationState: locationReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js